/**
 * Discovery Carousel [New] — full strip + compact sticky on scroll down
 * Sticky only appears after the sentinel leaves the viewport while scrolling down,
 * and sits under the site header (never covers it).
 */
(function () {
  var SECTION_TYPE = 'discovery-carousel-new';

  function enhance(root) {
    if (!root || root._vgDcReady) return;
    root._vgDcReady = true;

    var stickyEnabled = root.getAttribute('data-sticky') !== 'false';
    var sentinel = root.querySelector('[data-dc-sentinel]');
    var sticky = root.querySelector('[data-dc-sticky]');
    var fullTrack = root.querySelector('[data-dc-track]');
    var prevBtn = root.querySelector('[data-dc-prev]');
    var nextBtn = root.querySelector('[data-dc-next]');
    var lastY = window.scrollY || 0;
    var compact = false;
    var dirDown = false;
    var ioReady = false;

    function measureStickyTop() {
      if (!sticky) return;
      var ann =
        parseFloat(
          getComputedStyle(document.body).getPropertyValue('--sticky-announcement-bar-height')
        ) || 0;
      var headerEl =
        document.querySelector('.vg-header--sticky .vg-header__bar') ||
        document.querySelector('.vg-header__bar') ||
        document.querySelector('[data-vg-header-shell] .vg-header__bar') ||
        document.querySelector('.site-header');
      var hdr = 0;
      if (headerEl) {
        hdr = headerEl.getBoundingClientRect().height || 0;
      }
      if (!hdr) {
        hdr =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--vg-hdr-bar-h')
          ) || 80;
      }
      sticky.style.setProperty('--vg-dc-sticky-top', Math.round(ann + hdr) + 'px');
    }

    function setStickyVisible() {
      if (!sticky || !stickyEnabled) return;
      var y = window.scrollY || 0;
      /* Match React: past sentinel + scrolling down; never show at page top */
      var show = ioReady && compact && dirDown && y > 8;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function onScroll() {
      var y = window.scrollY || 0;
      dirDown = y > lastY;
      lastY = y;
      setStickyVisible();
    }

    measureStickyTop();
    window.addEventListener('resize', measureStickyTop, { passive: true });

    if (stickyEnabled && sentinel && typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          ioReady = true;
          compact = !entry.isIntersecting;
          setStickyVisible();
        },
        { threshold: 0, rootMargin: '-1px 0px 0px 0px' }
      );
      io.observe(sentinel);
    } else if (sticky) {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }

    function scrollBy(dir) {
      if (!fullTrack) return;
      fullTrack.scrollBy({ left: dir * fullTrack.clientWidth * 0.7, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(1); });

    function updateScrollState() {
      if (!fullTrack) return;
      var scrollable = fullTrack.scrollWidth > fullTrack.clientWidth + 2;
      root.classList.toggle('is-scrollable', scrollable);
      if (prevBtn) prevBtn.hidden = !scrollable;
      if (nextBtn) nextBtn.hidden = !scrollable;
    }

    updateScrollState();
    window.addEventListener('resize', updateScrollState, { passive: true });

    if (fullTrack && typeof ResizeObserver !== 'undefined') {
      var trackRo = new ResizeObserver(updateScrollState);
      trackRo.observe(fullTrack);
    }

    fullTrack.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', updateScrollState, { once: true });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target.querySelector &&
        event.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')) ||
      null;
    if (!root && event.target.getAttribute && event.target.getAttribute('data-section-type') === SECTION_TYPE) {
      root = event.target;
    }
    if (root) {
      root._vgDcReady = false;
      enhance(root);
    }
  });
})();
